export const CartCtrlState = {
    UNINITIALIZED: 1,
    INITIALIZING: 2,
    INITIALIZED: 3,
    UPDATING: 4,
    UPDATED: 5,
    ERROR_MAX_ARTICLE: 6,
    ERROR: 7,
    ERROR_ALREADY_SAME_ARTICLE: 8,
    ERROR_OUT_OF_STOCK: 9
};
Object.freeze(CartCtrlState);

export class CartCtrl {

    constructor({orderId, isLegacyCart, initCartAccessoryApiUrl, accessoriesCount}) {
        this.orderId = orderId;
        this.state = orderId != null ? CartCtrlState.INITIALIZED : CartCtrlState.UNINITIALIZED;
        this.isLegacyCart = isLegacyCart;
        this.initCartAccessoryApiUrl = initCartAccessoryApiUrl;
        this.accessoriesCount = accessoriesCount;
    }

    /**
     * Ajoute un accessoire standalone au panier
     * @param idSeo idSeo de l'accessoire à ajouter
     * @param shop boutique sur laquelle à lieu l'ajout de l'accessoire
     * @return retourne une {Promise} pour l'ajout d'accessoire
     */
    addAccessory(idSeo, shop) {
        if (this.state === CartCtrlState.UNINITIALIZED) {
            return this.initAccessoryCart(idSeo, shop)
                .then((response) => {
                    this.orderId = response.orderId
                    return this.fetchCart(this.orderId)
                })
        } else {
            return this.updateAccessory(this.orderId, idSeo, 1)
                .then(() => this.fetchCart(this.orderId))
        }
    }

    /**
     * Initialise le cart accessoire
     * @param idSeo idSeo de l'accessoire à ajouter
     * @param shop boutique sur laquelle à lieu l'ajout de l'accessoire
     * @return retourne une {Promise} pour l'init card
     */
    initAccessoryCart(idSeo, shop) {
        this.setState(CartCtrlState.INITIALIZING);
        return new Promise((resolve, reject) => {
            const body = {
                idSeo: idSeo,
                shop: shop
            }
            $.ajax({
                method: "POST",
                url: this.initCartAccessoryApiUrl,
                contentType: "application/json",
                data: JSON.stringify(body)
            }).done(data => {
                this.setState(CartCtrlState.UPDATED);
                resolve(data);
            }).fail(error => {
                this.setState(CartCtrlState.UNINITIALIZED);
                reject(error);
            });
        });
    }

    updateAccessory(orderId, idSeo) {
        this.setState(CartCtrlState.UPDATING);
        return new Promise((resolve, reject) => {
            const body = {
                idSeo: idSeo
            }
            let url = `/api/mobile/orders/${orderId}/accessories`
            $.ajax({
                method: "POST",
                url: url,
                contentType: "application/json",
                data: JSON.stringify(body)
            }).done(data => {
                resolve(data);
            }).fail(error => {
                if (error.status === 422) {
                    this.setState(CartCtrlState.ERROR_MAX_ARTICLE);
                } else if (error.status === 409) {
                    this.setState(CartCtrlState.ERROR_ALREADY_SAME_ARTICLE);
                } else if (error.status === 412) {
                    this.setState(CartCtrlState.ERROR_OUT_OF_STOCK);
                } else {
                    this.setState(CartCtrlState.ERROR);
                }
                reject(error);
            });
        });
    }

    /**
     * Récupère le cart courant
     */
    fetchCart(orderId) {

        // Dans le cas du cart legacy, on n'a pas d'api pour obtenir l'état du cart.
        // Comme on veut juste avoir le nouveau nombre d'accessoire au final, on fait
        // l'hypothèse qu'on a ajouté un accessoire au panier. Ce comportement n'est
        // pas "correcte" mais on peut l'accepter le temps de la mise en place du
        // nouveau tunnel.
        if (this.isLegacyCart) {
            this.accessoriesCount += 1;
            this.setState(CartCtrlState.UPDATED);
            return;
        }

        let url =  `/api/mobile/orders/${orderId}/cartinfo`

        return new Promise((resolve, reject) => {
            $.ajax({
                method: "GET",
                url: url,
                contentType: "application/json",
            }).done(data => {
                const {accessories} = data;
                let sum = 0;
                accessories.forEach(item => {
                    sum += item.quantity;
                });
                this.accessoriesCount = sum;
                this.setState(CartCtrlState.UPDATED);
                resolve(data);
            }).fail(error => {
                this.setState(CartCtrlState.ERROR);
                reject(error);
            });
        });
    }

    setState(state) {
        this.state = state;
    }
}
